import {
  connectionColumnID,
  devicesColumnID,
  groupColumnID,
  lastBackupColumnID,
  lastSentColumnID,
  nameColumnID,
  sizeColumnID,
  stateColumnID,
  uploadColumnID,
  versionColumnID,
} from "../Dialogs/ToggleReportColumns/Components/ColumnsList/ColumnsList";

const headersData = {
  headers: [
    {
      id: nameColumnID,
      UIText: {
        "es-CL": { label: "Usuarios" },
        "en-US": { label: "Users" },
      },
      filterKey: "user",
      size: "grow",
    },
    {
      id: devicesColumnID,
      UIText: {
        "es-CL": { label: "Dispositivos" },
        "en-US": { label: "Devices" },
      },
      filterKey: "name",
      size: "grow",
    },
    {
      id: groupColumnID,
      UIText: {
        "es-CL": { label: "Grupo" },
        "en-US": { label: "Group" },
      },
      filterKey: "group",
      size: "grow",
    },
    {
      id: sizeColumnID,
      UIText: {
        "es-CL": { label: "Tamaño" },
        "en-US": { label: "Size" },
      },
      filterKey: "space_active",
      size: 1,
    },
    {
      id: lastBackupColumnID,
      UIText: {
        "es-CL": { label: "Último respaldo" },
        "en-US": { label: "Last backup" },
      },
      filterKey: "lastBkp",
      size: 1.5,
    },
    {
      id: lastSentColumnID,
      UIText: {
        "es-CL": { label: "Último envío" },
        "en-US": { label: "Last update" },
      },
      filterKey: "lastChanges",
      size: 1.5,
    },
    {
      id: uploadColumnID,
      UIText: {
        "es-CL": { label: "Ancho de banda" },
        "en-US": { label: "Bandwidth" },
      },
      justify: "center",
      filterKey: "bandwidth",
      size: 0.8,
    },
    {
      id: versionColumnID,
      UIText: {
        "es-CL": { label: "Versión" },
        "en-US": { label: "Version" },
      },
      justify: "center",
      filterKey: "croppedVersion",
      size: 0.9,
    },
    {
      id: connectionColumnID,
      UIText: {
        "es-CL": { label: "Conexión" },
        "en-US": { label: "Connection" },
      },
      justify: "center",
      filterKey: "connected",
      size: 0.8,
    },
    {
      id: stateColumnID,
      UIText: {
        "es-CL": { label: "Estado" },
        "en-US": { label: "Status" },
      },
      justify: "center",
      filterKey: "status",
      size: 0.8,
    },
  ],
};

export default headersData;
